<div class="main-container">
	<div class="__body">
		<router-outlet></router-outlet>
	</div>
	<div class="__footer">
		<app-sponsors></app-sponsors>
	</div>
</div>
